import React from 'react';
import FormInput from 'components/Input/FormInput';

const PosNameField: React.FC = () => {
	return <FormInput testId="PosNameField" name="posName" label="posNameLabel" disabled={true} />;
};

export default React.memo(PosNameField);
